module.exports = "/fonts/vendor/typeface-inter/files/inter-latin-800.woff?11acf20988fd8fb6d06ac5be0ed9dd76";